export default __webpack_public_path__ + "img/logo-11576b7b.png";